import { createSelector } from 'reselect';

export const getState = (state) => state;

export const getAuth = createSelector(getState, (state) => {
    return state.auth;
});

export const getUserSource = createSelector(getState, (state) => {
    return state?.auth?.loggedUser?.source?.[0]?.id || null;
});

export const getUserRole = createSelector(getState, (state) => {
    return state?.auth?.loggedUser?.roles[0] || null;
});

export const getLayout = createSelector(getState, (state) => {
    return state.layout;
});

export const getMatterDetail = createSelector(getState, (state) => {
    return state.matterDetail;
});
